'use client';
import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { theme } from '@/components/features/theme/theme';

const Button = ({
					onSubmit,
					text,
					src, submit,
					img,
					hoverImg,
					fontSize,
					fontWeight,
					color,
					letterSpacing,
					lineHeight,
					margin,
					background,
					borderRadius,
					border,
					width,
					height,
					hoverBackground,
					target,
					borderColor,
					hoverColor,
					icon,
					marginSm,
					onClick,
					className,
				}) => {


	return (
		<StyledBtn onClick={onClick} className={`${className ? className : null} dc-btn `}
				   fontSize={fontSize}
				   fontWeight={fontWeight}
				   color={color}
				   background={background}
				   lineHeight={lineHeight}
				   letterSpacing={letterSpacing}
				   margin={margin}
				   border={border}
				   img={img}
				   borderRadius={borderRadius}
				   width={width}
				   hoverImg={hoverImg}
				   hoverBackground={hoverBackground}
				   height={height}
				   borderColor={borderColor}
				   target={target}
				   hoverColor={hoverColor}
				   onSubmit={onSubmit}
				   icon={icon}
				   marginSm={marginSm}
				   submit={submit}
		>
			{
				submit ?
					<a>
						<span>{text}</span>
					</a> :
					<Link href={src || '/'}>
						<span>{text}</span>
					</Link>

			}

		</StyledBtn>
	);
};

const StyledBtn = styled.div`
    &.dc-btn {
        margin: ${props => props.margin || '0'};
        width: ${props => props.width || '100%'};
        height: ${props => props.height || 'auto'};
        cursor: pointer;
        transition: ${theme.transition};

        a {
            display: flex;
            width: 100%;
            height: auto;
            align-items: start;
			text-align: center;
            justify-content: center;
            font-size: ${props => props.fontSize || '1rem'};
            letter-spacing: ${props => props.letterSpacing || '0'};
            font-weight: ${props => props.fontWeight || '700'};
            margin: 0;
            line-height: ${props => props.lineHeight || '1.5rem'};
            background-color: ${props => props.background || 'transparent'};
            position: relative;
            border-radius: ${props => props.borderRadius || '100'}px;
            overflow: hidden;
            padding: 10px 30px;
            box-sizing: border-box;
            border: ${p => p.border || '1px solid'};
            border-color: ${p => p.borderColor || theme.colors.themeColor400};
            color: ${props => props.color || theme.colors.themeColor400};
            z-index: 1;
            transition: ${theme.transition};

            &:after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) !important;
                width: 29px;
                height: 29px;
                border-radius: 20px;
                background-color: ${props => props.hoverBackground || theme.colors.hover};
                transition: ${theme.transition};
                opacity: 0;
            }


            span {
                z-index: 99;
            }

            &:hover {
                span {
                    color: ${props => props.hoverColor || theme.colors.white};
                }

                &:after {
                    width: 100%;
                    height: 100%;
                    opacity: 1;
                }

            }

            &:focus {
                color: ${props => props.color || '#282d31'};
            }
        }

        @media (max-width: 600px) {
            ${p => p.marginSm ? `margin:${p.marginSm}` : ''}
        }
    }




`;


export default Button;